import { render, staticRenderFns } from "./PromoCodesPage.vue?vue&type=template&id=84a0eb6a&scoped=true&"
import script from "./PromoCodesPage.vue?vue&type=script&lang=js&"
export * from "./PromoCodesPage.vue?vue&type=script&lang=js&"
import style0 from "./PromoCodesPage.vue?vue&type=style&index=0&id=84a0eb6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a0eb6a",
  null
  
)

export default component.exports